/**
 * Display labels and colors for subscription tier badges.
 * Keys mirror the API enum: blue, violet, silver_star, vip.
 */
export const TIER_LABELS = {
    blue: "Blue",
    violet: "Violet",
    silver_star: "Silver Star",
    vip: "VIP",
};

export const TIER_COLORS = {
    blue: { bg: "rgba(33, 150, 243, 0.15)", color: "rgba(100, 181, 246, 1)", border: "rgba(33, 150, 243, 0.4)" },
    violet: { bg: "rgba(156, 39, 176, 0.15)", color: "rgba(186, 104, 200, 1)", border: "rgba(156, 39, 176, 0.4)" },
    silver_star: { bg: "rgba(189, 189, 189, 0.15)", color: "rgba(224, 224, 224, 1)", border: "rgba(189, 189, 189, 0.4)" },
    vip: { bg: "rgba(255, 193, 7, 0.15)", color: "rgba(255, 213, 79, 1)", border: "rgba(255, 193, 7, 0.4)" },
};

/**
 * Display labels and colors for subscription status chips.
 * Keys mirror the API enum: active, pending, expired, cancelled.
 */
export const STATUS_LABELS = {
    active: "Actif",
    pending: "En attente",
    expired: "Expiré",
    cancelled: "Annulé",
};

export const STATUS_COLORS = {
    active: { bg: "rgba(76, 175, 80, 0.15)", color: "rgba(129, 199, 132, 1)", border: "rgba(76, 175, 80, 0.4)" },
    pending: { bg: "rgba(255, 152, 0, 0.15)", color: "rgba(255, 183, 77, 1)", border: "rgba(255, 152, 0, 0.4)" },
    expired: { bg: "rgba(158, 158, 158, 0.15)", color: "rgba(189, 189, 189, 1)", border: "rgba(158, 158, 158, 0.4)" },
    cancelled: { bg: "rgba(244, 67, 54, 0.15)", color: "rgba(229, 115, 115, 1)", border: "rgba(244, 67, 54, 0.4)" },
};

export const DEFAULT_CHIP_COLOR = {
    bg: "rgba(255, 255, 255, 0.08)",
    color: "rgba(255, 255, 255, 0.7)",
    border: "rgba(255, 255, 255, 0.2)",
};

/**
 * Display labels and colors for the payment provider badge.
 * Keys mirror the API enum: stripe (recurring card) and orange_money
 * (prepaid month block, no Stripe object attached).
 */
export const PROVIDER_LABELS = {
    stripe: "Stripe",
    orange_money: "Orange Money prépayé",
};

export const PROVIDER_COLORS = {
    stripe: { bg: "rgba(99, 91, 255, 0.15)", color: "rgba(154, 148, 255, 1)", border: "rgba(99, 91, 255, 0.4)" },
    orange_money: { bg: "rgba(255, 121, 0, 0.15)", color: "rgba(255, 167, 77, 1)", border: "rgba(255, 121, 0, 0.4)" },
};

export const ORANGE_MONEY_PROVIDER = "orange_money";

/**
 * Available subscription tiers for the create form.
 * Order matches the visual hierarchy (lowest to highest).
 */
export const TIER_OPTIONS = ["blue", "violet", "silver_star", "vip"];

/**
 * Allowed currency codes per the API spec.
 */
export const CURRENCY_OPTIONS = ["EUR", "CHF", "DKK", "GBP", "NOK", "SEK", "MGA"];

/**
 * Allowed duration in months for free subscriptions (1 to 12 inclusive).
 */
export const DURATION_MONTHS_OPTIONS = Array.from({ length: 12 }, (_, i) => i + 1);

/**
 * Display labels for Stripe invoice statuses.
 */
export const INVOICE_STATUS_LABELS = {
    draft: "Brouillon",
    open: "Ouverte",
    paid: "Payée",
    uncollectible: "Irrécouvrable",
    void: "Annulée",
};

export const INVOICE_STATUS_COLORS = {
    paid: { bg: "rgba(76, 175, 80, 0.15)", color: "rgba(129, 199, 132, 1)", border: "rgba(76, 175, 80, 0.4)" },
    open: { bg: "rgba(255, 152, 0, 0.15)", color: "rgba(255, 183, 77, 1)", border: "rgba(255, 152, 0, 0.4)" },
    draft: { bg: "rgba(158, 158, 158, 0.15)", color: "rgba(189, 189, 189, 1)", border: "rgba(158, 158, 158, 0.4)" },
    uncollectible: { bg: "rgba(244, 67, 54, 0.15)", color: "rgba(229, 115, 115, 1)", border: "rgba(244, 67, 54, 0.4)" },
    void: { bg: "rgba(120, 120, 120, 0.15)", color: "rgba(160, 160, 160, 1)", border: "rgba(120, 120, 120, 0.4)" },
};

/** Number of invoices to fetch per page. */
export const INVOICES_PAGE_SIZE = 20;
